import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteCollectiveItem } from '../../services/compositionApi';

// « Mes envois » sur la page de l'invite (2026-10-29) : ce que CETTE personne a envoye, et le retrait de ce qui n'est pas encore
// place dans le livre. Un envoi deja place (page ou couverture) reste : seul l'organisateur peut le retirer (decision du fondateur,
// la mise en page du createur ne change jamais sans lui). Retrait en deux temps (« Retirer » puis « Confirmer »), annonce aux
// lecteurs d'ecran. Le serveur reverifie tout (son envoi, pas place, livre pas verrouille).
export default function MesEnvois({ token, items, onRetire }) {
  const { t } = useTranslation('collective');
  const [ouvert, setOuvert] = useState(false);
  const [aConfirmer, setAConfirmer] = useState(null);
  const [enCours, setEnCours] = useState(null);
  const [annonce, setAnnonce] = useState('');
  const [erreur, setErreur] = useState('');

  if (!Array.isArray(items) || items.length === 0) return null;

  const retirer = async (item) => {
    setEnCours(item.id);
    setErreur('');
    try {
      await deleteCollectiveItem(token, item.id);
      setAConfirmer(null);
      setAnnonce(item.kind === 'photo' ? t('guest.mine.removedPhoto') : t('guest.mine.removedWord'));
      onRetire(item.id);
    } catch (err) {
      setErreur(err.message || t('participate.sendFailed'));
    } finally {
      setEnCours(null);
    }
  };

  return (
    <div className="cg-mine">
      <button type="button" className="cg-link" aria-expanded={ouvert} aria-controls="cg-mine-list" onClick={() => setOuvert((o) => !o)}>
        {ouvert ? t('guest.mine.hide') : t('guest.mine.show', { count: items.length })}
      </button>
      <p className="cg-sr" role="status" aria-live="polite">{annonce}</p>
      {ouvert && (
        <div id="cg-mine-list">
          <p className="cg-fine">{t('guest.mine.hint')}</p>
          {erreur && <p className="cg-err" role="alert">{erreur}</p>}
          <ul className="cg-mine-list">
            {items.map((item, index) => (
              <li key={item.id} className="cg-mine-item">
                {item.kind === 'photo'
                  ? <img src={item.thumbnailUrl} alt={t('guest.photoN', { n: index + 1 })} loading="lazy" />
                  : <blockquote>« {item.text} »</blockquote>}
                {item.placed ? (
                  <span className="cg-mine-placed">{t('guest.mine.placed')}</span>
                ) : aConfirmer === item.id ? (
                  <span className="cg-mine-confirm">
                    <button type="button" className="cg-mine-btn is-danger" onClick={() => retirer(item)} disabled={enCours === item.id} autoFocus>
                      {enCours === item.id ? t('guest.mine.removing') : t('guest.mine.confirm')}
                    </button>
                    <button type="button" className="cg-mine-btn" onClick={() => setAConfirmer(null)} disabled={enCours === item.id}>{t('guest.mine.cancel')}</button>
                  </span>
                ) : (
                  <button type="button" className="cg-mine-btn" onClick={() => { setErreur(''); setAConfirmer(item.id); }}>
                    {t('guest.mine.remove')}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
